import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities_municipalityIdDashboard = z.any()
export type TagsGetMunicipalities_municipalityIdDashboard = z.infer<typeof tagsGetMunicipalities_municipalityIdDashboard>

export const paramsGetMunicipalities_municipalityIdDashboard = z.object({ "municipalityId": z.string() })
export type ParamsGetMunicipalities_municipalityIdDashboard = z.infer<typeof paramsGetMunicipalities_municipalityIdDashboard>

export const responseGetMunicipalities_municipalityIdDashboard = z.object({ "payload": z.object({ "totalBuildings": z.number(), "totalCollectionPoints": z.number(), "totalInvoices": z.number(), "totalConsumptions": z.number() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetMunicipalities_municipalityIdDashboard = z.infer<typeof responseGetMunicipalities_municipalityIdDashboard>

interface IGetMunicipalities_municipalityIdDashboard extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdDashboard,
  params: ParamsGetMunicipalities_municipalityIdDashboard,
  response: ResponseGetMunicipalities_municipalityIdDashboard
}
export const URL = '/municipalities/:municipalityId/dashboard'
export const validation = {
  get: {
    tags: tagsGetMunicipalities_municipalityIdDashboard,
    params: paramsGetMunicipalities_municipalityIdDashboard,
    response: responseGetMunicipalities_municipalityIdDashboard
  }
}
export interface Municipalities_municipalityIdDashboard extends BaseRouteType {
  get: IGetMunicipalities_municipalityIdDashboard
}